import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtenerCajas() {
    var url = ConfigAPI.baseURL + "finances-cash" + Session.getToken();
    return instance.get(url);
  },
  mostrarCaja(id) {
    var url = ConfigAPI.baseURL + "finances-cash/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarCaja(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "finances-cash" + Session.getToken();
    return instance.post(url,params);
  },
  editarCaja(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cash/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarCaja(id) {
    var url = ConfigAPI.baseURL + "finances-cash/"+ id + Session.getToken();
    return instance.delete(url);
  },
  
  filtrarCajaDetalle(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cash-detail/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },

  obtenerCheques() {
    var url = ConfigAPI.baseURL + "finances-cheques" + Session.getToken();
    return instance.get(url);
  },
  mostrarCheque(id) {
    var url = ConfigAPI.baseURL + "finances-cheques/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarCheque(data) {    
    var params = data
    var url = ConfigAPI.baseURL + "finances-cheques" + Session.getToken();
    return instance.post(url,params);
  },
  editarCheque(data) {    
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cheques/"+ data.id + Session.getToken();
    return instance.post(url,params);
  },
  eliminarCheque(id) {
    var url = ConfigAPI.baseURL + "finances-cheques/"+ id + Session.getToken();
    return instance.delete(url);
  },
  filtrarCheques(data, page) {
    var params = data    
    var url = ConfigAPI.baseURL + "finances-cheques/filter/query" + Session.getToken() + "&page=" + page;
    return instance.post(url,params);
  },
}

export default servicesAPI;